import { IUserSelectionRepository, UserSelectionInformation } from "../../../domain/user";
import { AuthenticatedService } from "../..";
import { UserSelectionInformationTranslator } from "./UserSelectionInformationTranslator";

export class UserSelectionRepository extends AuthenticatedService implements IUserSelectionRepository {
  constructor(getToken: () => string) {
    super(getToken);
  }

  public async getUserSelection(): Promise<UserSelectionInformation> {
    const result = await this.get("api/settings/userSelection/get");
    const translator = new UserSelectionInformationTranslator();
    return translator.toUserSelectionInformation(result.data);
  }

  public async saveUserSelection(info: UserSelectionInformation): Promise<void> {
    const translator = new UserSelectionInformationTranslator();
    const bean = translator.toUserSelectionBean(info);
    await this.post("api/settings/userSelection/save", bean);
  }
}
